import { defineWebModule } from '@itc/sdk';

// Ping in the shell (design §7.5, plan 5E): the page where an audience is built and sent or scheduled, the schedules, autorole's rules,
// their nav entries and its admin section.
export default defineWebModule({
  name: 'ping',
  title: 'Ping',
  routes: [
    { path: '/ping', component: () => import('./pages/PingPage.vue'), meta: { permission: 'ping.send', title: 'Ping' } },
    { path: '/ping/schedules', component: () => import('./pages/SchedulesPage.vue'), meta: { permission: 'ping.schedule', title: 'Ping schedules' } },
    { path: '/ping/rules', component: () => import('./pages/RulesPage.vue'), meta: { permission: 'ping.admin', title: 'Autorole rules' } },
  ],
  nav: [
    { label: 'Ping', to: '/ping', permission: 'ping.send', icon: 'people' },
    { label: 'Ping schedules', to: '/ping/schedules', permission: 'ping.schedule', icon: 'people' },
    { label: 'Autorole rules', to: '/ping/rules', permission: 'ping.admin', icon: 'people' },
  ],
  admin: [{ label: 'Ping', path: '/admin/ping', component: () => import('./admin/AdminPage.vue'), permission: 'ping.admin' }],
});
